/*=========================================================================================
  File Name: state.js
  Namespace: reporting
  Description: Vuex Store - IFrame state
==========================================================================================*/


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  reportingList: null,
  count: 0,
  next: null,
  previous: null,
  results: [],
}

export default state